import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '@appEnv/environment';
import { VssApiService } from '../../../projects/vss-ui/src/vss-ui/services/vss-api.service';

@Injectable({
  providedIn: 'root'
})
export class AuthService extends VssApiService {
  baseUrl = environment.apiUrl
  url = '/api/v1/admin'
  getCountry() {
    return this.get(`${this.url}/get-list-country`)
  }
  // getUserRoles() {
  //   return this.api.get(`${this.url}/get-list-country`)
  // }
  postSearchStaffCustom(pageNumber: number, pageSize: number, searchStaffDTO: Partial<any>): Observable<AppResponseModel<any>> {
    return this.post(`${this.url}/user/search-staff-custom?pageNumber=${pageNumber}&pageSize=${pageSize}`, searchStaffDTO)
  }
  getAllModules(): Observable<AppResponseModel<any[]>> {
    return this.get(`${this.url}/get-all-menu`)
  }
  // getUserRoles(): Observable<AppResponseModel<any[]>> {
  //   return this.get(`${this.url}/get-my-roles`)
  // }
  getUserRoles(): Observable<AppResponseModel<any[]>> {
    return this.get(`${this.url}/my-roles`)
  }
  searchStaffsCustom(params: any, payload: any): Observable<AppResponseModel<any[]>> {
    return this.post(`${this.url}/staff/search-staff-custom`, payload, { pageNumber: params.page, pageSize: params.size })
  }

  getListDepartmentByIds(ids: number[]) {
    return this.get(`${this.contextPath}/organization/findByIds`, { ids })
  }
  postDepartmentList(param: any, body: any): Observable<AppResponseModel<any>> {
    return this.post(`${this.contextPath}/organization/get-list`, body, param)
  }
  getUserRolesAll(): Observable<AppResponseModel<any[]>> {
    return this.get(`${this.contextPath}/my-roles/all`, { applicationCode: environment.applicationCode })
  }
  get getUserInfo(): any {
    return JSON.parse(localStorage.getItem('ticket') as any)?.authenticationSuccess?.attributes;
  }

  get getRoleOrg() {
    return JSON.parse(localStorage.getItem('ticket') as any)?.authenticationSuccess?.roleOrg || []
  }

  isManager(orgId: any) {
    return this.getRoleOrg.some((role: any) => role?.orgId == orgId && role?.roleOrg == 'MANAGER')
  }

  get getUsername(): any {
    return JSON.parse(localStorage.getItem('ticket') as any)?.authenticationSuccess?.user;
  }

  set rememberedUsername(rememberedUsername: any) {
    localStorage.setItem('rememberedUsername', rememberedUsername);
  }

  get getRememberedUsername() {
    return localStorage.getItem('rememberedUsername');
  }

  set rememberedPassword(password: any) {
    localStorage.setItem('rememberedPassword', password);
  }

  get getRememberedPassword() {
    return localStorage.getItem('rememberedPassword');
  }

  set authentication(authentication: any) {
    localStorage.setItem('ticket', JSON.stringify(authentication))
  }

  set localIp(localIp: any) {
    localStorage.setItem('localIp', localIp)
  }

  get getLocalIp() {
    return localStorage.getItem('localIp') || ''
  }

  isAdministrator() {
    return this.getUserInfo?.role === 'Administrator'
  }
}

export interface AppResponseModel<T> {
  code: string;
  data: any;
  message?: string;
  status?: string;
}
